import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class delay extends ASTBlock {
    constructor(color) {
        super(color, "delay")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "warte %1 Sekunden",
            "args0": [{
                "type": "field_number",
                "name": "value"
            }],
            "previousStatement": null,
            "nextStatement": null
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}